module.exports = __webpack_public_path__ + "static/img/s4.3631a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/s4.png
// module id = lQAG
// module chunks = 1